import { render, staticRenderFns } from "./usercreate_promotion.vue?vue&type=template&id=5bda6d7b&scoped=true&"
import script from "./usercreate_promotion.vue?vue&type=script&lang=js&"
export * from "./usercreate_promotion.vue?vue&type=script&lang=js&"
import style0 from "./usercreate_promotion.vue?vue&type=style&index=0&id=5bda6d7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda6d7b",
  null
  
)

export default component.exports